import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IAddressList from '../../interfaces/IAddressList'
import { FindAddressRequest } from '../../services/api/interfaces/ApiRequest'
import { findAddress } from '../../services/api'

interface AddressContextState extends BaseContextState {
  addressList: IAddressList[] | null
}

interface AddressContextData extends AddressContextState {
  resetErrors: Function,
  requestAddress: (args: FindAddressRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as AddressContextData)

// Export consumer
export const AddressConsumer = Consumer

export class AddressProvider extends BaseContextProvider {
  state: AddressContextState = {
    addressList: null
  }

  /**
   * Make api request address
   * 
   * @param {FindAddressRequest} payload 
   */
   requestAddress = (payload: FindAddressRequest) => {
    this.setState({
      fetching: true,
      error: null,
      addressList: null
    }, async () => {
      const response = await findAddress(payload)

      // Process our response
      this.processResponse(response, { 
        mappings: [
          { origin: 'list', destination: 'addressList' },
        ]
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestAddress: this.requestAddress
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
